
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class ServicesService extends CommonService {
  async getServices(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`services/?${query}`);
  }
  async getServiceStore(params?: { [key: string]: string | boolean }) {
    const query = generateQueryParams(params);
    return await this.get(`service-stores/?${query}`);
  }
  async createServices(parmas: { [key: string]: boolean | string }) {
    return await this.post('services', parmas)
  }
}
export const servicesService = new ServicesService();
